import { Component, OnInit } from '@angular/core';
import { EOtpremnicaStavka } from './eotpremnica-stavka';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContainerService, BaseModalUpdateComponent, ModalService } from 'yt-ng-framework';

@Component({
  selector: 'yt-eotpremnica-stavka-modal-update',
  templateUrl: './eotpremnica-stavka-modal-update.component.html'
})
export class EOtpremnicaStavkaModalUpdateComponent
 extends BaseModalUpdateComponent<EOtpremnicaStavka> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<EOtpremnicaStavka>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  izlazna: boolean = false;

      ngOnInit() {
        super.ngOnInit(); 
          this.izlazna=this.modelData.MainTitle==='Izlazna otpremnica';
      }
}
